'use client'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function WhyChooseOur({ cardData, title, desc, otherUi = false }) {
   return (
      <section className={`features ${otherUi ? 'ind-features' : ''}`}>
         <div className="container container-4xxl">
            <h4 className="section_heading_title tech_title">{title}</h4>
            <p className="section_desc features_description mb-3 pb-5">
               {desc}
            </p>

            <div className="container model_train feature_service d-md-inline d-none">
               <div className="features_row mb-3">
                  {cardData.map((card, index) => (
                     <div className="feature_card" key={index}>
                        <div className="feature_card_img">{card.icon}</div>
                        <div className="feature_card_border"></div>
                        <h3 className="feature_card_title">{card.title}</h3>
                        <p className="feature_card_subtitle">{card.subtitle}</p>
                        <p className="feature_card_description">
                           {card.description}
                        </p>
                     </div>
                  ))}
               </div>
            </div>
            <div className="d-md-none d-inline slider-column">
               <div className="model_train_slider container-fluid position-relative mb-3">
                  <Swiper
                     modules={[Navigation, Pagination, Autoplay]}
                     slidesPerView={2}
                     spaceBetween={3}
                     loop={true}
                     navigation={{
                        nextEl: '.model_train_slider_custom_next_btn3',
                        prevEl: '.model_train_slider_custom_prev_btn3',
                     }}
                     autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                     }}
                     pagination={{
                        el: '.feature-pagination',
                        dynamicBullets: false,
                        clickable: true,
                        renderBullet: function (index, className) {
                           return `<span class="${className} custom-bullet"></span>`
                        },
                     }}
                     breakpoints={{
                        320: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        768: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1025: {
                           slidesPerView: 1,
                           spaceBetween: 30,
                        },
                        1200: {
                           slidesPerView: 2,
                           spaceBetween: 30,
                        },
                     }}
                     className="feature-slider"
                  >
                     {cardData.map((card, index) => (
                        <SwiperSlide key={index}>
                           <div className="feature_card why-choose-wrap p-3">
                              <div className="feature_card_img">
                                 {card.icon}
                              </div>
                              <div className="feature_card_border"></div>
                              <h3 className="feature_card_title">
                                 {card.title}
                              </h3>
                              <p className="feature_card_subtitle">
                                 {card.subtitle}
                              </p>
                              <p className="feature_card_description">
                                 {card.description}
                              </p>
                           </div>
                        </SwiperSlide>
                     ))}
                     <div className="model_train_slider_custom_prev_btn3"></div>
                     <div className="model_train_slider_custom_next_btn3"></div>
                     <div className="d-xl-none d-flex align-items-center justify-content-center mt-4">
                        <span className="d-flex align-items-center justify-content-center feature-pagination"></span>
                     </div>
                  </Swiper>
               </div>
            </div>
         </div>
      </section>
   )
}

export default WhyChooseOur
